<template>
  <div>
    <Table
      resource="PaymentMethod"
      :detail-route="row => `/payment-methods/${row.id}/detail`"
      :actions="actions"
      :items="$store.getters['paymentMethod/tableData']"
      :detail="$store.getters['paymentMethod/detailData']"
      :fields="$store.getters['paymentMethod/tableFields']"
      :pagination="$store.state.paymentMethod.tablePagination"
      :keyword="$store.state.paymentMethod.tableKeyword"
      :loading="$store.state.paymentMethod.loadingTable"
      :filter="$store.state.paymentMethod.tableFilter"
      :sort="$store.state.paymentMethod.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/v2/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('paymentMethod/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('paymentMethod/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('paymentMethod/delete', id)
        .then(() => {
          callback()
        })
        .catch(err => {
          callback(err)
        })
    },
    resetDetail() {
      this.$store.commit('paymentMethod/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('paymentMethod/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('paymentMethod/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('paymentMethod/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('paymentMethod/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('paymentMethod/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('paymentMethod/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
